module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C137"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C140"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Prologue#page_1"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_The_World_of_Animation_and_the_A#page_7"
    }
  }, [_vm._v("The World of Animation and the Animation of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema#page_17"
    }
  }, [_vm._v("The LEGO Movie")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08_The_LEGO_Movie_as_Savvy_Cinema#page_17"
    }
  }, [_vm._v("as Savvy Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Through_the_Rabbit_Hole__into_th#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Through the Rabbit Hole, into the LEGO-Verse")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Falling_into_Narrative#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falling into Narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_The_Extraordinary_Ordinariness_o#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Extraordinary Ordinariness of LEGO")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_The_Secret_Life_of_Toys#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secret Life of Toys")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Production_History__Part_1__Proj#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production History, Part 1: "), _c('em', [_vm._v("Project Development as LEGO Goes to the Movies")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Production_History__Part_2__The#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production History, Part 2: "), _c('em', [_vm._v("The Animation Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Production_History__Part_3__The#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Production History, Part 3: "), _c('em', [_vm._v("The Screenwriter-Directors")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Reception_and_After_Life#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reception and After-Life")])]), _vm._v(" "), _c('p', {
    staticClass: "C141"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Coda#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda")])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Acknowledgments#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_LEGO_Bibliography#page_199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEGO Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C140"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 72
// module chunks = 0